import { render } from "./member-blog.vue?vue&type=template&id=bb8f7822"
import script from "./member-blog.vue?vue&type=script&lang=js"
export * from "./member-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__